export default function (html) {
  if (!html) return "";

  const config = useRuntimeConfig();
  const baseUrl = new URL(config.public.appBaseUrl);
  const baseHostname = baseUrl.hostname.replace("www.", "");

  const result = html.replace(
    /<a\s+([^>]*href\s*=\s*["']([^"']+)["'][^>]*)>(.*?)<\/a>/gis,
    (match, attrs, href, innerText) => {
      try {
        const url = new URL(href, config.public.appBaseUrl);
        const hostname = url.hostname;

        if (hostname === baseHostname || hostname === `www.${baseHostname}`) {
          return `<a ${attrs}>${innerText}</a>`;
        } else {
          if (config.public.feature.contentLinks) {
            const hasTarget = /target\s*=\s*["'][^"']*["']/.test(attrs);
            const hasRel = /rel\s*=\s*["'][^"']*["']/.test(attrs);

            let newAttrs = attrs;
            if (!hasTarget) newAttrs += ' target="_blank"';
            if (!hasRel) newAttrs += ' rel="noopener noreferrer"';

            return `<a ${newAttrs}>${innerText}</a>`;
          } else {
            return innerText;
          }
        }
      } catch {
        return match;
      }
    }
  );

  return result;
}
